var React = require('react');

function LogoX (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18.2439 2.25H21.5519L14.3249 10.51L22.8269 21.75H16.1699L10.9559 14.933L4.98991 21.75H1.67991L9.40991 12.915L1.25391 2.25H8.07991L12.7929 8.481L18.2439 2.25ZM17.0829 19.77H18.9159L7.08391 4.126H5.11691L17.0829 19.77Z","fill":"#318EFF"}));
}

LogoX.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = LogoX;

LogoX.default = LogoX;
